import { render, staticRenderFns } from "./pagination-bubble.vue?vue&type=template&id=dc1b06ba"
import script from "./pagination-bubble.vue?vue&type=script&lang=js"
export * from "./pagination-bubble.vue?vue&type=script&lang=js"
import style0 from "./pagination-bubble.vue?vue&type=style&index=0&id=dc1b06ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports